interface IProps {
  name: string;
}

const PackagePublisherItem = ({ name }: IProps) => {
  return <li className='py-1 px-3 rounded-md hover:bg-[#1b43321f] cursor-default'>{name}</li>;
};

export default PackagePublisherItem;
